import React from 'react';
import bgImage from '../../../assets/images/bg_img.svg';
import visionIcon from '../../../assets/images/vision_icon.svg';
import missionIcon from '../../../assets/images/mission_icon.svg';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo_icon.svg';
// import useDocumentTitle from '../../../hooks/useDocumentTitle';
import bgLeft from '../../../assets/images/journey_left_icon.svg';
import bgRight from '../../../assets/images/journey_right_icon.svg';
import AboutUsPageHelmet from '../../HelmetComponents/AboutUsPageHelmet';

const AboutUs: React.FC = () => {
  // useDocumentTitle('About Us');
  return (
    <>
      <AboutUsPageHelmet />
      <section className='w-full'>
        {/* For Mobile: Solid Background, No Image */}
        <div className='md:hidden bg-[#F8F8F8] h-[300px] flex flex-col items-center justify-center text-center'>
          <h1 className='text-[#4A2D1A] font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-bold mt-4 drop-shadow-[0_2px_2px_rgba(0,0,0,0.7)]'>
            ABOUT US
          </h1>
          <div className='flex justify-center mt-4 w-full px-4'>
            <img src={aboutImage} alt='About Us Manikchand' className='max-w-full h-auto' />
          </div>
        </div>

        {/* For Desktop/Tablet: Background Image */}
        <div
          className='hidden md:flex flex-col items-center justify-center h-[600px] text-center'
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <h2 className='text-[#4A2D1A] font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-bold mt-4 drop-shadow-[0_2px_2px_rgba(0,0,0,0.7)]'>
            ABOUT US
          </h2>
          <div className='flex justify-center mt-4 w-full px-4'>
            <img src={aboutImage} alt='About Us Manikchand' className='max-w-full h-auto' />
          </div>
        </div>

        {/* --- Vision & Mission Cards --- */}
        <div className='max-w-7xl mx-auto px-4 sm:px-4 md:px-14 lg:px-14 py-6 sm:py-6 md:py-24 lg:py-24 grid grid-cols-1 md:grid-cols-2 gap-6'>
          {/* Vision */}
          <div className='bg-white shadow rounded-xl p-4 sm:p-4 md:p-6 lg:p-6 flex flex-col hover:shadow-lg transition-shadow duration-300'>
            <div
              className='flex items-center space-x-4 border-b pb-4 mb-4'
              style={{
                borderBottom: '2px solid',
                borderImageSource:
                  'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
                borderImageSlice: 1,
              }}
            >
              <img src={visionIcon} alt='Vision' className='w-10 h-10 sm:w-12 sm:h-12' />
              <h3 className='font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-semibold text-[#4A2D1A]'>
                VISION
              </h3>
            </div>
            <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg leading-relaxed text-justify'>
              At Namasteji Manikchand, our vision is not merely a statement—it is the guiding principle that shapes
              every facet of our journey in the pan masala industry. From the very inception of our brand, we have
              strived to transcend conventional boundaries, creating a legacy that is built on trust, authenticity, and
              excellence. Our aim is to emerge as the most admired and respected brand in the pan masala segment,
              recognized not only for the superior quality of our products but also for our commitment to preserving the
              rich traditions of Indian taste while embracing the innovations of the modern world.
            </p>
          </div>

          {/* Mission */}
          <div className='bg-white shadow-md rounded-xl p-4 sm:p-4 md:p-6 lg:p-6 flex flex-col hover:shadow-lg transition-shadow duration-300'>
            <div
              className='flex items-center space-x-4 border-b pb-4 mb-4'
              style={{
                borderBottom: '2px solid',
                borderImageSource:
                  'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
                borderImageSlice: 1,
              }}
            >
              <img src={missionIcon} alt='Mission' className='w-10 h-10 sm:w-12 sm:h-12' />
              <h3 className='text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-semibold text-[#4A2D1A] font-rubik'>
                MISSION
              </h3>
            </div>
            <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg leading-relaxed text-justify'>
              We are dedicated to crafting premium pan masala using carefully selected ingredients, advanced technology,
              and world-class manufacturing standards to ensure every pack provides an unmatched experience of flavor,
              freshness, and satisfaction. We aim to be the best by fostering a culture of continuous improvement,
              innovation, and customer-centricity. Every process, from sourcing raw materials to packaging and
              distribution, is designed to uphold the highest standards of quality and consistency. By embracing modern
              technology while respecting traditional craftsmanship, we create products that honor India’s rich heritage
              and appeal to discerning consumers across generations.
            </p>
          </div>
        </div>

        {/* --- Our Journey So Far --- */}
        <div
          className='relative px-4 sm:px-8 md:px-16 py-4 sm:py-4 md:py-18 lg:py-18  md:py-24 bg-[#ffff] overflow-hidden'
          style={{
            // borderBottom: "1px solid",
            borderTop: '1px solid',
            borderImageSource:
              'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
            borderImageSlice: 1,
          }}
        >
          {/* Left Icon */}
          <img
            src={bgRight}
            alt='Our Journey So Far'
            className='absolute -left-[25%] top-1/2 transform -translate-y-1/2 opacity-[25%] h-full hidden sm:block'
          />

          {/* Right Icon */}
          <img
            src={bgLeft}
            alt='Our Journey So Far'
            className='absolute -right-[25%] top-1/2 transform -translate-y-1/2 opacity-[25%] h-full hidden sm:block'
          />

          <div className='max-w-6xl mx-auto flex flex-col sm:flex-row justify-center !items-center sm:items-start gap-3 sm:gap-3 md:gap-5 lg:gap-5 relative z-10'>
            {/* 1st Column: Logo + Title */}
            <div className='flex flex-col items-center text-center '>
              <img
                src={logo}
                alt='Namasteji Logo'
                className='w-16 h-10 sm:w-16 sm:h-10 md:w-20 md:h-12 lg:w-20 lg:h-12  object-contain -mb-1 sm:-mb-1 md:mb-0 lg:mb-0'
              />
              <h2 className='font-rubik text-[#4A2D1A] font-bold text-4xl sm:text-5xl leading-tight'>Manikchand</h2>
            </div>

            {/* 2nd Column: Heading + Paragraph */}
            <div className='flex-1'>
              <h2 className='font-rubik text-[#4A2D1A] font-bold uppercase text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] mb-4 sm:mb-5 text-center sm:text-left'>
                Why Choose Namasteji Manikchand?
              </h2>
              {/* <p
                className='font-poppins text-[#000000] text-sm sm:text-sm md:text-lg lg:text-lg leading-relaxed pt-4 sm:pt-6 text-justify'
                style={{
                  borderTop: '2px solid',
                  borderImageSource:
                    'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
                  borderImageSlice: 1,
                }}
              >
                From the very beginning, Namasteji Manikchand journey has been driven by a passion for purity and
                perfection. With a steadfast focus on authentic flavors and uncompromised quality, we have grown into a
                brand that embodies trust, reliability, and modern standards. Our journey reflects a perfect balance of
                heritage and progress, setting new benchmarks in flavor, consistency, and excellence. Today, Namasteji
                Manikchand stands as a trusted name, valued by millions for delivering an authentic pan masala
                experience.
              </p> */}
              <ol
                className='list-disc space-y-1 sm:space-y-1 md:space-y-2 lg:space-y-2 pl-5 pt-4 sm:pt-6 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-black leading-relaxed text-justify'
                style={{
                  borderTop: '2px solid',
                  borderImageSource:
                    'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
                  borderImageSlice: 1,
                }}
              >
                <li className='text-justify'>
                  <strong>Heritage of Taste</strong>: Decades of expertise in crafting pan masala blends that reflect
                  India’s rich flavor traditions.
                </li>
                <li className='text-justify'>
                  <strong>Premium Ingredients</strong>: Only quality raw materials and strict quality assurance,
                  ensuring every morsel meets high standards.
                </li>
                <li className='text-justify'>
                  <strong>Modern Manufacturing</strong>: State-of-the-art facilities, hygienic production, and efficient
                  logistics to maintain freshness and consistency.
                </li>
                <li className='text-justify'>
                  <strong>Trusted Brand</strong>: A brand that retailers, distributors and end-users alike rely upon for
                  taste, quality and service..
                </li>
                <li className='text-justify'>
                  <strong>Innovative Range</strong>: A variety of flavor profiles, packaging formats and offerings
                  designed for evolving consumer tastes.
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* --- At a Glance Section --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            AT A GLANCE
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='At a Glance Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Namasteji Manikchand at a glance represents a legacy of authentic taste, uncompromised quality, and customer
            trust. With a strong presence in the pan masala industry, we are known for blending heritage with innovation
            to deliver products that meet modern standards while preserving traditional flavors. Our commitment to
            excellence, purity, and consistency has made us a trusted choice for millions, setting us apart as a symbol
            of reliability in the market.
          </p>
        </section>

        {/* --- Our Heritage & Journey --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            OUR HERITAGE & JOURNEY
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            The story of Namasteji Manikchand begins with a deep respect for Indian tradition — the centuries-old custom
            of paan and savoury mouth-freshening blends that bring people together. Inspired by this cultural ritual,
            our founders set out to craft a pan masala brand that reflects authenticity, refined taste and modern
            manufacturing excellence. Over the years, as consumer tastes evolved and standards rose, Namasteji
            Manikchand remained committed to quality ingredients, hygienic production, and consistent flavor.
          </p>
          <br />
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            From small beginnings, our distribution network expanded across cities and states, and our blends reached
            households, retailers and hospitality settings. Today, the brand is recognised for offering a versatile
            product range that appeals to both traditional preferences and contemporary sensibilities.
          </p>
        </section>

        {/* Our Philosophy */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            OUR PHILOSOPHY
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            At the heart of Namasteji Manikchand lies a philosophy of “Taste with Integrity.” We believe that every
            pouch of our pan masala should deliver not just a moment of enjoyment, but also reflect our commitment to
            excellence. This means sourcing quality ingredients, maintaining strict manufacturing hygiene protocols, and
            continuously innovating to meet consumer expectations. We honour tradition — while embracing innovation.
            <br />
            <br />
            We hold ourselves accountable to the expectations of our customers, trade partners and the communities we
            operate in. Respect, trust and transparency guide our interactions. Whether you are a retailer, distributor
            or end-user, you will find in Namasteji Manikchand a brand that stands behind its product.
          </p>
        </section>

        {/* --- PREMIUM QUALITY --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            PREMIUM QUALITY
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Ensuring premium quality is not just a tagline for Namasteji Manikchand—it is the way we operate. From
            ingredient selection to packaging, every step is monitored and aligned with best practices. We invest in
            modern manufacturing facilities, internationally-recognised safety standards and robust logistics to ensure
            freshness and flavor reach you just as intended.
            <br />
            <br />
            Moreover, our research and development teams work tirelessly to refine blends, incorporate consumer feedback
            and introduce new variants that stay true to the brand’s character. Our packaging is designed not only to
            preserve aroma and taste, but also to present a premium look and feel that reflects the value our customers
            expect.
          </p>
        </section>

        {/* --- PACKAGING--- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            PACKAGING
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='premium quality Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            At Namasteji Manikchand, packaging is more than just a wrapper—it’s a promise of freshness, quality, and
            care. Each pack is designed to preserve the authentic flavor and aroma of our premium pan masala, ensuring
            the same delightful experience every time. With modern, hygienic, and eco-friendly packaging solutions, we
            focus on both consumer convenience and environmental responsibility. Whether it’s our 2g or 4g pack, every
            detail reflects our dedication to delivering excellence from production to your hands.
          </p>
        </section>

        {/* --- Product Range & Innovation--- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#ffffff]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            PRODUCT RANGE & INNOVATION
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='premium quality Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Throughout the years, Namasteji Manikchand has built a diverse product range catering to varied taste
            profiles. From classic blends rich in aroma and tradition, to newer offerings designed for the modern
            palate, we combine tradition, creativity and expertise. Each variant maintains the signature essence of the
            brand — a balanced flavor, refined taste and a memorable experience.
            <br />
            <br />
            In addition to consumer-oriented variants, we also support trade partners with dedicated programmes,
            customised packaging, prompt logistics and consistent supply. Our brand is built not only for consumers, but
            also for retailers and distributors who place their trust in us.
          </p>
        </section>

        {/* --- Our Reach & Network--- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            OUR REACH & NETWORK
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='premium quality Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Namasteji Manikchand’s presence spans across India, reaching urban centres, tier-2 towns and rural markets
            alike. Our distribution network is backed by trained teams, efficient logistics and a strong dealer-retailer
            ecosystem. We believe in forming long-term partnerships, offering support, training and transparency to our
            network.
            <br />
            <br />
            As part of our mission, we also explore export opportunities, emerging markets and new distribution
            channels. Every day brings a chance to serve new regions and new consumers who appreciate authentic taste
            and trusted quality.
          </p>
        </section>

        {/* ---Join Us on the Journey --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            JOIN US ON THE JOURNEY
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Research and Development Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>

          <p
            className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'
            style={{
              borderBottom: '1px solid',
              // borderTop: '1px solid',
              borderImageSource:
                'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
              borderImageSlice: 1,
              paddingBottom: '3%',
            }}
          >
            Whether you are a loyal consumer, a retailer looking for a reliable brand, or a distributor seeking a
            premium partner — Namasteji Manikchand invites you to experience the difference. Explore our range, feel the
            aroma, savour the taste, and become part of our tradition. Together, let’s carry forward the legacy of
            flavor.
          </p>
          <br />
          <Link to='/contact'>
            <button className='font-rubik mt-2 sm:mt-2 md:mt-4 lg:mt-4 px-8 sm:px-12 py-3 bg-red-700 text-white rounded-xl hover:bg-red-800 transition'>
              Contact Us
            </button>
          </Link>
        </section>
      </section>
    </>
  );
};

export default AboutUs;
